export const messageCodes: { [key: number]: string } = {
  10001: "apiMessages.expertRelatedCodes.10001",
  10002: "apiMessages.expertRelatedCodes.10002",
  10003: "apiMessages.expertRelatedCodes.10003",

  20001: "apiMessages.lessonRelatedCodes.20001",
  20002: "apiMessages.expertRelatedCodes.20002",
  20003: "apiMessages.lessonRelatedCodes.20003",
  20004: "apiMessages.lessonRelatedCodes.20004",

  30001: "apiMessages.reservationRelatedCodes.30001",
  30002: "apiMessages.reservationRelatedCodes.30002",
  30003: "apiMessages.reservationRelatedCodes.30003",
  30004: "apiMessages.reservationRelatedCodes.30004",
  30005: "apiMessages.reservationRelatedCodes.30005",
  30006: "apiMessages.reservationRelatedCodes.30006",
  30007: "apiMessages.reservationRelatedCodes.30007",
  30008: "apiMessages.reservationRelatedCodes.30008",
  30009: "apiMessages.reservationRelatedCodes.30009",
  30010: "apiMessages.reservationRelatedCodes.30010",
  30011: "apiMessages.reservationRelatedCodes.30011",
  30012: "apiMessages.reservationRelatedCodes.30012",
  30013: "apiMessages.reservationRelatedCodes.30013",

  40001: "apiMessages.scheduleRelatedCodes.40001",
  40002: "apiMessages.scheduleRelatedCodes.40002",
  40003: "apiMessages.scheduleRelatedCodes.40003",
  40004: "apiMessages.scheduleRelatedCodes.40004",
  40015: "apiMessages.scheduleRelatedCodes.40015",

  60001: "apiMessages.commonCodes.60001",
  60002: "apiMessages.commonCodes.60002",
  60003: "apiMessages.commonCodes.60003",
  60004: "apiMessages.commonCodes.60004",
  60005: "apiMessages.commonCodes.60005",

  70001: "apiMessages.otherCodes.70001",
  70002: "apiMessages.otherCodes.70002",
  70003: "apiMessages.otherCodes.70003",
  70004: "apiMessages.otherCodes.70004",
  70005: "apiMessages.otherCodes.70005",
  70006: "apiMessages.otherCodes.70006",
  70007: "apiMessages.otherCodes.70007",
  70008: "apiMessages.otherCodes.70008",
  70009: "apiMessages.otherCodes.70009",
  70010: "apiMessages.otherCodes.70010",

  80001: "apiMessages.authenticationCodes.80001",
  80002: "apiMessages.authenticationCodes.80002",
};
export const messageCodesFrontEnd: { [key: number]: string } = {
  11001: "feMessages.common.11001", //"Error occurred"

  12001: "feMessages.auth.12001",
  12002: "feMessages.auth.12002",
  12003: "feMessages.auth.12003",
  12004: "feMessages.auth.12004",
  12005: "feMessages.auth.12005",
  12006: "feMessages.auth.12006",

  13001: "feMessages.bankDetails.13001",

  14001: "feMessages.expertProfile.14001",
  14002: "feMessages.expertProfile.14002",
  14003: "feMessages.expertProfile.14003",
  14004: "feMessages.expertProfile.14004",
  14005: "feMessages.expertProfile.14005",
  14006: "feMessages.expertProfile.14006",
  14007: "feMessages.expertProfile.14007",
  14008: "feMessages.expertProfile.14008",
  14009: "feMessages.expertProfile.14009",

  15001: "feMessages.expertSchedule.15001",
  15002: "feMessages.expertSchedule.15002",
  15003: "feMessages.expertSchedule.15003",
  15004: "feMessages.expertSchedule.15004",

  16001: "feMessages.lessons.16001",
  16002: "feMessages.lessons.16002",
  16003: "feMessages.lessons.16003",
  16004: "feMessages.lessons.16004",

  17001: "feMessages.profile.17001",
  17002: "feMessages.profile.17002",

  18001: "feMessages.reservations.18001",
  18002: "feMessages.reservations.18002",
  18003: "feMessages.reservations.18003",
  18004: "feMessages.reservations.18004",
  18005: "feMessages.reservations.18005",
  18006: "feMessages.reservations.18006",
  18007: "feMessages.reservations.18007",
  18008: "feMessages.reservations.18008",
  18009: "feMessages.reservations.18009",
  18010: "feMessages.reservations.18010",

  19001: "feMessages.lesson.19001",

  20001: "feMessages.studentSelectReservationTimeSlot.20001",

  21001: "feMessages.useAuth.21001",
  21002: "feMessages.useAuth.21002",

  22001: "feMessages.editProfile.22001",
  22002: "feMessages.editProfile.22002",

  23001: "feMessages.expertEnrollmentsLessonReport.23001",

  24001: "feMessages.purchaseArea.24001",

  25001: "feMessages.expertLessonHistory.25001",

  26001: "feMessages.expertsList.26001",
  26002: "feMessages.expertsList.26002",
  26003: "feMessages.expertsList.26003",
  26004: "feMessages.expertsList.26004",

  27001: "feMessages.reservationRate.27001"
};
